<template>
  <div class="w100p class pointer" @click.prevent="onClick(link)">
    <div class="alerts-heading display-flex justify-between align-center">
      <h4 class="f1-2 text-black">{{ title }}</h4>
      <p class="f1 text-violet">
        Details &rarr;
      </p>
    </div>
    <div class="alert-info-container display-flex justify-evenly">
      <bh-chart class="donut-chart w60p-mb" :options="options"></bh-chart>
      <div class="w50p mt2">
        <div class="f1-5 display-flex justify-between align-center" v-for="legend in legends" :key="legend.name">
          <div class="display-flex justify-start align-center">
            <span class="circle"></span>
            <span class="ml1 name text-left">{{ legend.name }}</span>
          </div>
          <div class="display-flex align-center">
            <span class="value">{{ legend.value }}</span>
            <span class="alerts-points-arrow f-5 pl1">
              <bh-icon :icon="stautsIcons[legend.status].name" :class="stautsIcons[legend.status].class"/>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'bh-alerts',
  props: {
    title: {
      type: String
    },
    link: {
      type: String
    },
    legends: {
      type: Array
    },
    options: {
      type: Object
    }
  },
  data() {
    return {
      stautsIcons: {
        '-1': {
          name: 'play-down',
          class: 'green'
        },
        0: {
          name: 'play-down',
          class: 'green'
        },
        1: {
          name: 'play-up',
          class: 'red'
        }
      }
    }
  },
  methods: {
    onClick(name) {
      if (name) this.$router.push({ name })
    }
  }
}
</script>

<style scoped>
.circle {
  background-color: #ffffff;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  border: 1px solid #a9b3eb;
}

.name {
  color: #959595;
}

.red {
  color: #ed4e55;
}

.green {
  color: #5cc954;
}

.value {
  color: #000000;
}

.donut-chart {
  height: 14rem;
  width: 12rem;
}
</style>
